import type { App } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import { useScannerStore } from 'stores/scanner'

const pinia = createPinia().use(piniaPluginPersistedState)

export function installPinia(app: App) {
  app.use(pinia)

  const store = useScannerStore()

  window._setScannerData = (arr: string[]) => {
    if (Array.isArray(arr)) {
      store.setData(arr)
    }
  }
}

export { pinia }
